import { SubmitWarrantyRegistrationState } from "@redotech/redo-return-ui/flows/return-flow/submit-warranty-registration";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const SubmitWarrantyRegistrationDetails = memo(
  function SubmitWarrantyRegistrationDetails({
    state,
    setState,
  }: StepTypeDetailsProps<SubmitWarrantyRegistrationState>) {
    return <Text>This submits a warranty registration</Text>;
  },
);
